<div class="consumption-popover">
  <span class="popover-title">{{ 'Recent consumption' | translate }}</span>
  @if (isLoading) {
    <div class="popover-loading">{{ 'Loading...' | translate }}</div>
  }
  @if (!isLoading && !groups.length) {
    <div class="popover-empty">{{ 'No recent credit usage' | translate }}</div>
  }
  @if (!isLoading && groups.length) {
    <ul class="consumption-list">
      @for (group of groups; track trackByDay($index, group)) {
        <li>
          <span class="entry-date">
            @if (group.label.type === 'translated') {
              {{ group.label.key | translate }}
            } @else {
              {{ group.label.date }}
            }
          </span>
          <span class="entry-credits">-{{ group.total | number }}</span>
        </li>
      }
    </ul>
  }
</div>
